import { getApiBase } from "./auth";

export type ArlaAerialProductItem = {
  regnum: string;
  product_name: string;
  registrant: string;
  product_type: string;
  product_type_label: string;
  auth_snippets: string;
  label_url: string;
};

export type ArlaAerialProductsPayload = {
  source_file: string;
  source_description: string;
  updated_at: number;
  total: number;
  product_types: { id: string; label: string; count: number }[];
  registrants: { name: string; count: number }[];
  items: ArlaAerialProductItem[];
};

export async function fetchArlaAerialProducts(): Promise<ArlaAerialProductsPayload> {
  const response = await fetch(`${getApiBase()}/public/arla-aerial-products/data`);
  if (!response.ok) {
    const detail = await response.text();
    throw new Error(detail || "Impossible de charger la liste ARLA");
  }
  return response.json();
}
